export const CENTER_MIDDLE_TITLE = '主播工作台'
